import type { DivisionsConfig } from '../../../domain/types/configs/company/DivisionsConfig';

export const divisionsConfig: DivisionsConfig = {
  divisions: [
    {
      name: "Otros",
      label: "PRE | Otros",
      value: "PRE"
    },
    {
      name: "Otros",
      label: "MER | Otros",
      value: "MER"
    },
    {
      value: "TEC",
      label: "TEC | Otros",
      name: "Otros"
    },
    {
      name: "Banco de Sangre",
      label: "BS1 | Banco de Sangre",
      value: "BS1"
    },
    {
      label: "BM1 | Biologia Molecular",
      name: "Biologia Molecular",
      value: "BM1"
    },
    {
      label: "IN2 | Industrias",
      name: "Industrias",
      value: "IN2"
    },
    {
      name: "Industrias",
      label: "IN1 | Industrias",
      value: "IN1"
    },
    {
      name: "Laboratorio Clinico",
      label: "LC2 | Laboratorio Clinico",
      value: "LC2"
    },
    {
      value: "LC1",
      name: "Laboratorio Clinico",
      label: "LC1 | Laboratorio Clinico"
    },
    {
      value: "CA",
      name: "Laboratorio Clinico",
      label: "CA | Laboratorio Clinico"
    },
    {
      label: "LH | Laboratorio Clinico",
      name: "Laboratorio Clinico",
      value: "LH"
    },
    {
      name: "Laboratorio Clinico",
      value: "FA1",
      label: "FA1 | Laboratorio Clinico"
    },
    {
      value: "LDC",
      label: "LDC | Metrología",
      name: "Metrología"
    },
    {
      label: "SDF | Servicio Tecnico - Lab",
      name: "Servicio Tecnico - Lab",
      value: "SDF"
    },
    {
      label: "SLA | Servicio Tecnico - Lab",
      name: "Servicio Tecnico - Lab",
      value: "SLA"
    },
    {
      name: "Diagnostico Por Imagen",
      value: "DXI",
      label: "DXI | Diagnostico Por Imagen"
    },
    {
      name: "Diagnostico Por Imagen",
      value: "PM1",
      label: "PM1 | Diagnostico Por Imagen"
    },
    {
      value: "KO1",
      label: "KO1 | Diagnostico Por Imagen",
      name: "Diagnostico Por Imagen"
    },
    {
      name: "Diagnostico Por Imagen",
      label: "MC1 | Diagnostico Por Imagen",
      value: "MC1"
    },
    {
      value: "DMN",
      name: "Diagnostico Por Imagen",
      label: "DMN | Diagnostico Por Imagen"
    },
    {
      name: "Diagnostico Por Imagen",
      label: "PC1 | Diagnostico Por Imagen",
      value: "PC1"
    },
    {
      value: "RT1",
      label: "RT1 | Radioterapia",
      name: "Radioterapia"
    },
    {
      label: "DMN | Diagnostico Por Imagen",
      value: "DMN",
      name: "Diagnostico Por Imagen"
    },
    {
      label: "IMA | Diagnostico Por Imagen",
      name: "Diagnostico Por Imagen",
      value: "IMA"
    },
    {
      name: "Diagnostico Por Imagen",
      label: "RHM | Diagnostico Por Imagen",
      value: "RHM"
    },
    {
      name: "Radioterapia",
      value: "RTS",
      label: "RTS | Radioterapia"
    },
    {
      label: "IM1 | Informatica Medica",
      value: "IM1",
      name: "Informatica Medica"
    },
    {
      name: "Proyecto",
      value: "PR1",
      label: "PR1 | Proyecto"
    },
    {
      name: "Ultrasonido",
      value: "US1",
      label: "US1 | Ultrasonido"
    },
    {
      name: "Especialidades Clinicas y farmaceuticas",
      label: "NC1 | Especialidades Clinicas y farmaceuticas",
      value: "NC1"
    },
    {
      value: "EC1",
      label: "EC1 | Especialidades Clinicas y farmaceuticas",
      name: "Especialidades Clinicas y farmaceuticas"
    },
    {
      name: "Especialidades Clinicas y farmaceuticas",
      label: "FA1 | Especialidades Clinicas y farmaceuticas",
      value: "FA1"
    },
    {
      name: "Especialidades Clinicas y farmaceuticas",
      label: "NC2 | Especialidades Clinicas y farmaceuticas",
      value: "NC2"
    },
    {
      label: "MED | Especialidades Clinicas y farmaceuticas",
      value: "MED",
      name: "Especialidades Clinicas y farmaceuticas"
    },
    {
      value: "DM1",
      name: "Especialidades Clinicas y farmaceuticas",
      label: "DM1 | Especialidades Clinicas y farmaceuticas"
    },
    {
      name: "Especialidades Renales",
      label: "ER5 | Especialidades Renales",
      value: "ER5"
    },
    {
      label: "ER1 | Especialidades Renales",
      value: "ER1",
      name: "Especialidades Renales"
    },
    {
      label: "ER2 | Especialidades Renales",
      name: "Especialidades Renales",
      value: "ER2"
    },
    {
      label: "RE | Proceso De Valor Agregado (PVA)",
      name: "Proceso De Valor Agregado (PVA)",
      value: "RE"
    },
    {
      label: "PT | Proceso De Valor Agregado (PVA)",
      name: "Proceso De Valor Agregado (PVA)",
      value: "PT"
    },
    {
      label: "TPN | Proceso De Valor Agregado (PVA)",
      name: "Proceso De Valor Agregado (PVA)",
      value: "TPN"
    },
    {
      name: "Proceso De Valor Agregado (PVA)",
      value: "KH",
      label: "KH | Proceso De Valor Agregado (PVA)"
    },
    {
      value: "SPV",
      label: "SPV | Proceso De Valor Agregado (PVA)",
      name: "Proceso De Valor Agregado (PVA)"
    },
    {
      name: "Proceso De Valor Agregado (PVA)",
      label: "QT | Proceso De Valor Agregado (PVA)",
      value: "QT"
    },
    {
      value: "EM1",
      name: "Equipos Medicos",
      label: "EM1 | Equipos Medicos"
    },
    {
      label: "EM2 | Equipos Medicos",
      value: "EM2",
      name: "Equipos Medicos"
    },
    {
      label: "PAS | Equipos Medicos",
      name: "Equipos Medicos",
      value: "PAS"
    },
    {
      value: "EQ3",
      label: "EQ3 | Especialidades Quirurgicas",
      name: "Especialidades Quirurgicas"
    },
    {
      name: "Especialidades Quirurgicas",
      label: "EQ8 | Especialidades Quirurgicas",
      value: "EQ8"
    },
    {
      label: "EQG | Especialidades Quirurgicas",
      value: "EQG",
      name: "Especialidades Quirurgicas"
    },
    {
      name: "Especialidades Quirurgicas",
      label: "EQ9 | Especialidades Quirurgicas",
      value: "EQ9"
    },
    {
      value: "EQ0",
      name: "Especialidades Quirurgicas",
      label: "EQ0 | Especialidades Quirurgicas"
    },
    {
      label: "EQ1 | Especialidades Quirurgicas",
      name: "Especialidades Quirurgicas",
      value: "EQ1"
    },
    {
      label: "EQ5 | Especialidades Quirurgicas",
      name: "Especialidades Quirurgicas",
      value: "EQ5"
    },
    {
      name: "Especialidades Quirurgicas",
      value: "EQS",
      label: "EQS | Especialidades Quirurgicas"
    },
    {
      name: "Especialidades Quirurgicas",
      value: "EQ6",
      label: "EQ6 | Especialidades Quirurgicas"
    },
    {
      label: "EQI | Especialidades Quirurgicas",
      value: "EQI",
      name: "Especialidades Quirurgicas"
    },
    {
      name: "Especialidades Quirurgicas",
      label: "EQ4 | Especialidades Quirurgicas",
      value: "EQ4"
    },
    {
      label: "EQ7 | Especialidades Quirurgicas",
      name: "Especialidades Quirurgicas",
      value: "EQ7"
    },
    {
      value: "EQ2",
      label: "EQ2 | Especialidades Quirurgicas",
      name: "Especialidades Quirurgicas"
    },
    {
      value: "ES1",
      name: "Especialidades Renales",
      label: "ES1 | Especialidades Renales"
    },
    {
      label: "ES5 | Especialidades Renales",
      name: "Especialidades Renales",
      value: "ES5"
    },
    {
      name: "Especialidades Renales",
      label: "ES6 | Especialidades Renales",
      value: "ES6"
    },
    {
      name: "Especialidades Renales",
      label: "ES3 | Especialidades Renales",
      value: "ES3"
    },
    {
      label: "ES2 | Especialidades Renales",
      value: "ES2",
      name: "Especialidades Renales"
    },
    {
      label: "ES4 | Especialidades Renales",
      value: "ES4",
      name: "Especialidades Renales"
    },
    {
      name: "Intervencionismo Vascular",
      label: "IV1 | Intervencionismo Vascular",
      value: "IV1"
    },
    {
      label: "IV2 | Intervencionismo Vascular",
      value: "IV2",
      name: "Intervencionismo Vascular"
    },
    {
      name: "Intervencionismo Vascular",
      value: "IV6",
      label: "IV6 | Intervencionismo Vascular"
    },
    {
      value: "IV5",
      label: "IV5 | Intervencionismo Vascular",
      name: "Intervencionismo Vascular"
    },
    {
      name: "Intervencionismo Vascular",
      value: "IV3",
      label: "IV3 | Intervencionismo Vascular"
    },
    {
      value: "IV4",
      label: "IV4 | Intervencionismo Vascular",
      name: "Intervencionismo Vascular"
    },
    {
      name: "Intervencionismo Vascular",
      value: "CI1",
      label: "CI1 | Intervencionismo Vascular"
    },
    {
      value: "CI3",
      label: "CI3 | Intervencionismo Vascular",
      name: "Intervencionismo Vascular"
    },
    {
      name: "Intervencionismo Vascular",
      label: "EC1 | Intervencionismo Vascular",
      value: "EC1"
    },
    {
      value: "PSI",
      label: "PSI | Proyecto",
      name: "Proyecto"
    },
    {
      name: "Servicio Tecnico ",
      value: "DI1",
      label: "DI1 | Servicio Tecnico "
    },
    {
      value: "PR",
      name: "Servicio Tecnico ",
      label: "PR | Servicio Tecnico "
    },
    {
      name: "Servicio Tecnico ",
      label: "SDI | Servicio Tecnico ",
      value: "SDI"
    },
    {
      name: "Servicio Tecnico ",
      value: "SME",
      label: "SME | Servicio Tecnico "
    },
    {
      value: "SEM",
      label: "SEM | Servicio Tecnico ",
      name: "Servicio Tecnico "
    },
    {
      value: "SIT",
      name: "Servicio Tecnico ",
      label: "SIT | Servicio Tecnico "
    },
    {
      label: "SE2 | Servicio Tecnico ",
      value: "SE2",
      name: "Servicio Tecnico "
    },
    {
      value: "SM2",
      label: "SM2 | Servicio Tecnico ",
      name: "Servicio Tecnico "
    },
    {
      name: "Servicio Tecnico ",
      label: "PAS | Servicio Tecnico ",
      value: "PAS"
    },
    {
      name: "Servicio Tecnico ",
      value: "STM",
      label: "STM | Servicio Tecnico "
    },
    {
      name: "Servicio Tecnico ",
      value: "SDF",
      label: "SDF | Servicio Tecnico "
    },
    {
      label: "US | Servicio Tecnico ",
      value: "US",
      name: "Servicio Tecnico "
    },
    {
      label: "EO1 | Especialidades Oftalmologicas",
      value: "EO1",
      name: "Especialidades Oftalmologicas"
    }
  ]
}; 